// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230029/js/" + chunkId + "." + {"44":"f03968ae","225":"607a68f7","481":"856b36e9","486":"5c4c37c6","770":"6621ecaa"}[chunkId] + ".0.4439948664495098.chunk.js";
};